import React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import StyledBackgroundSection from "../components/fullscreenSection"
import Styled from "styled-components";

import Icon from "../images/logo.svg"

import {Link} from "gatsby"



const NotFoundPage = () => (
  <Layout>
    <Seo title="404: Not found" />
    <StyledBackgroundSection>
        <div className="centerblock">
          <Icon />
          <Message>
          <p>Beklager denne siden eksisterer ikke</p>
          <Link to="/"> Gå tilbake til forsiden</Link>
          </Message>
        </div>
      </StyledBackgroundSection>
  </Layout>
)



const Message = Styled.div `
  background-color: #fff;
  padding: 35px;
  width: 50%;
margin: 0 auto;
border-radius: 15px;
margin-top: 15px;

p {
  margin: 0
}

`

export default NotFoundPage
